import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useNavigationContext } from "../../context/navigation/NavigationContext";
import useCurrentPath from "../hooks/useCurrentPath";
import { COLORS } from "../../ui/Theme";

export const MobileNavigationList = ({ data }) => {
  const { setIsMobileNavigation } = useNavigationContext();
  const { route2 } = useCurrentPath();

  return (
    <>
      {data.items.map((item) => (
        <Link to={item.link} key={item.label}>
          <Typography
            onClick={() => setIsMobileNavigation(false)}
            sx={{
              bgcolor:
                route2?.route === item.route
                  ? COLORS.SOFTBLUE
                  : COLORS.SOFTGRAY,
              color: route2?.route === item.route ? COLORS.BLUE : "inherit",
              fontSize: "14px",
              p: "6px",
              borderRadius: 2,
              ":hover": {
                bgcolor: COLORS.SOFTBLUE,
                color: COLORS.BLUE,
              },
            }}
          >
            {item.label}
          </Typography>
        </Link>
      ))}
    </>
  );
};
